<template>
  <div class="hello">
    <Navbar></Navbar>
    <h4
      class="card-title"
      style="padding-top:30px;padding-bottom:30px;background-color:#c3c3c338;"
    >404 NOT FOUND</h4>
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <p style="text-align:justify;font-size:18px;">
           Sorry, the page you are looking doesn't exists
           </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Navbar from "./navbar";
export default {
  name: "HelloWorld",
  props: {
    msg: String
  },
  components: {
    Navbar
  }
};
</script>
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>